import React, { FunctionComponent } from 'react';
import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';
import StaticTextPage from '@/components/pageComponents/StaticTextPage';
import { getTextPage } from '@/pageGeneration/services/prismicApi/textPagesApi';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';
import PageSeo from '@/components/seo/PageSeo';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';

interface IProps {
  title: string;
  subtitle: string;
  text: IPrismicRichTextElement[];
}

const PAGE_ID = 'terms';

const Terms: FunctionComponent<IProps> = ({ title, subtitle, text }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.STATIC, name: 'Terms' });

  return (
    <UnprotectedPage>
      <BarHeaderLayout>
        <PageSeo title={title} noIndex noFollow />
        <StaticTextPage title={title} subtitle={subtitle} text={text} />
      </BarHeaderLayout>
    </UnprotectedPage>
  );
};

export default Terms;

export async function getStaticProps() {
  try {
    const textPageData = await getTextPage(PAGE_ID);
    return packageStaticProps({
      title: textPageData.title,
      subtitle: textPageData.subtitle,
      text: textPageData.text,
    });
  } catch (e) {
    return {
      notFound: true,
    };
  }
}
